'use client'
import { P, match } from 'ts-pattern'
import { TRPCClientError } from '@trpc/client'
import { ZodError } from 'zod'
import { captureException } from '@sentry/nextjs'
import { environment, renderZodError } from 'src/environment'
import { identity } from 'lodash'

export const captureClientError = (error: unknown) => {
  const capturedError = match(error)
    .with(
      P.instanceOf(TRPCClientError),
      (error) =>
        (error as { data?: { zodError?: Error } }).data?.zodError ??
        error.cause ??
        error
    )
    .with(
      P.instanceOf(ZodError),
      (error) =>
        new Error(renderZodError(error, 'Captured Zod Error in client'), {
          cause: error,
        })
    )
    .otherwise(identity)

  if (environment.NEXT_PUBLIC_ENV !== 'development') {
    captureException(capturedError)
  }

  console.error(capturedError)
}
